import { css } from '@emotion/react';

export const useStyles = () => ({
  pagination: css`
    justify-content: flex-start;
  `,
});
